import 'css-chunksrc/client/scenes/wbsConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_1hfi1_1",
  "listRoot": "_listRoot_1hfi1_14",
  "list": "_list_1hfi1_14",
  "item": "_item_1hfi1_30",
  "icon": "_icon_1hfi1_43",
  "name": "_name_1hfi1_51"
};